export const getAddressesPending = (state) => state.addresses.pending
